import { REACT_APP_SITE_MODE } from "config";

export const isVac = () => REACT_APP_SITE_MODE === 'VAC';